import { useIntl } from 'react-intl';
import {
  AuthoredEvidence,
  TableCells,
  TableColumn,
  TableFilterCells,
} from '@eas/common-web';
import { ResearchQuery } from '@models';
import { useIpEntryModes } from './ip-entry-api';

export function useColumns(): TableColumn<ResearchQuery>[] {
  const intl = useIntl();
  const { authoredColumns } =
    AuthoredEvidence.useAuthoredColumns<ResearchQuery>();

  return [
    {
      datakey: 'ip',
      name: intl.formatMessage({
        id: 'TAPIS__IP_ENTRY__COLUMN__IP',
        defaultMessage: 'IP adresa',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },

    {
      datakey: 'mode',
      filterkey: 'mode.id',
      sortkey: 'mode.name',
      name: intl.formatMessage({
        id: 'TAPIS__IP_ENTRY__COLUMN__IP_BLOCK_MODE',
        defaultMessage: 'Mód',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterSelectCellFactory(useIpEntryModes),
      valueMapper: TableCells.useSelectCellFactory(useIpEntryModes),
      sortable: true,
      filterable: true,
    },

    /*     {
      datakey: 'tags',
      sortkey: 'tags.concatenated',
      filterkey: 'tags.id',
      name: intl.formatMessage({
        id: 'IP__FAQS__COLUMN__TAGS',
        defaultMessage: 'Klíčová slova',
      }),
      width: 200,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterAutocompleteCellFactory(useTags),
      valueMapper: localizedDictionaryArrayColumnMapper,
      sortable: true,
      filterable: true,
    }, */

    ...authoredColumns,
  ];
}
